module.exports = __webpack_public_path__ + "img/pinterest.0c137bfb.svg";